// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3pNkd","box":"WorkspacesBox_box__1KYcs","node":"WorkspacesBox_node__3k1Zz"};